var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }

import React from "react";
export default ((_ref) => {
  let {
    styles = {}
  } = _ref,
      props = _objectWithoutProperties(_ref, ["styles"]);

  return React.createElement(
    "svg",
    _extends({ width: "126", height: "125", xmlns: "http://www.w3.org/2000/svg", overflow: "hidden" }, props),
    React.createElement(
      "defs",
      null,
      React.createElement(
        "clipPath",
        { id: "a" },
        React.createElement("path", { d: "M239 282h126v125H239z" })
      )
    ),
    React.createElement(
      "g",
      { clipPath: "url(#a)", transform: "translate(-239 -282)" },
      React.createElement("path", { d: "M239.962 300.79a3.26 3.26 0 0 1 .414-4.61 3.311 3.311 0 0 1 4.233 0l10.937 10.8 24.162-23.96a3.322 3.322 0 0 1 4.657 0 3.382 3.382 0 0 1 0 4.61l-26.53 26.32a3.322 3.322 0 0 1-4.658 0zm62.043.97h59.673c1.815 0 3.307-1.46 3.307-3.28 0-1.81-1.492-3.27-3.307-3.27h-59.582c-1.815 0-3.307 1.46-3.307 3.27 0 1.82 1.492 3.28 3.307 3.28zm-62.043 45.21l13.266 13.16a3.31 3.31 0 0 0 4.647 0l26.53-26.27a3.296 3.296 0 0 0 0-4.62 3.31 3.31 0 0 0-4.647 0l-24.162 23.96-10.936-10.8a3.322 3.322 0 0 0-4.657 0 3.395 3.395 0 0 0 0 4.62zm62.043.97h59.673c1.815 0 3.307-1.47 3.307-3.28 0-1.81-1.492-3.28-3.307-3.28h-59.582c-1.815 0-3.307 1.47-3.307 3.28 0 1.81 1.492 3.28 3.307 3.28zm0 46.18h59.673c1.815 0 3.307-1.47 3.307-3.28 0-1.81-1.492-3.28-3.307-3.28h-59.582c-1.815 0-3.307 1.47-3.307 3.28 0 1.81 1.492 3.28 3.307 3.28zm-24.202-18.75a3.27 3.27 0 0 0-4.607-.05c0 .02-.05.04-.05.05l-10.937 10.85-10.937-10.85c-1.401-1.16-3.498-.98-4.657.42a3.245 3.245 0 0 0 0 4.2l10.887 10.8-10.887 10.85a3.273 3.273 0 0 0-.423 4.62c1.17 1.39 3.266 1.58 4.657.42.14-.13.282-.27.423-.42l10.937-10.8 10.937 10.8a3.318 3.318 0 0 0 4.657-.42 3.27 3.27 0 0 0 0-4.2l-10.897-10.85 10.897-10.8a3.315 3.315 0 0 0 0-4.62z", fill: "#EB6608" })
    )
  );
});